import './App.css';
import { useState, useEffect } from 'react';

import Header from './Header/Header';
import PageContent from './PageContent/PageContent';
// import CookieConsent from './CookieConsent/CookieConsent';

import RequestedAmount from "./Components/RequestedAmount";
import LoanPurpose from './Components/LoanPurpose';
import CreditScore from './Components/CreditScore';
import EmployeeInfo from './Components/EmployeeInfo';
import MonthlyIncome from './Components/MonthlyIncome';
import PersonalInfo from './Components/PersonalInfo';
import OwnHome from './Components/OwnHome';
import CitizenshipStatus from './Components/CitizenshipStatus';
import DebtAmount from './Components/DebtAmount';
import DebtStatus from './Components/DebtStatus';
import CreditAuth from './Components/CreditAuth';

import { Grid } from '@mui/material';

function App() {
  // const [page, setPage] = useState(sessionStorage.getItem("pageView") || 0);
  const [page, setPage] = useState(0);
  
  const [openForm, setOpenForm] = useState(false);
  // quebec only
  // const [openForm, setOpenForm] = useState(true);

  const [formData, setFormData] = useState({
    requestedAmount: "",
    productPurpose: "",
    creditScore: "",
    incomeType: "",
    employer: "",
    jobTitle: "",
    workPhone: "",
    employedMonths: "",
    payFrequency: "",
    payDate1: "",
    payDate2: "",
    monthlyIncome: "",
    directDeposit: "",
    address: "",
    postalCode: "",
    city: "",
    state: "",
    // state: "QC",
    email: "",
    firstName: "",
    lastName: "",
    cellPhone: "",
    dob: "",
    ownHome: "",
    propertyValue: "",
    propertyMortgage: "",
    canadianStatus: "",
    addressLengthMonths: "",
    rentMortgagePayment: "",
    credit_auth: 1,
    ccDebtAmount: "",
    unsecuredDebtAmount: "",
    inDebtProgram: "",
    inBankruptcy: "",
    inConsumerProposal: "",
    optIn: "no",
    ipAddress: "",
    lang: "en"
  });

  const setToEnglish = () => {
    setFormData(formData => ({ ...formData, lang: "en" }));
  }

  const setToFrench = () => {
    setFormData(formData => ({ ...formData, lang: "fr" }));
  }

  useEffect(() => {
    const fetchData = () => {
      fetch('https://api.ipify.org/?format=json')
        .then(response => response.json())
        .then((data) => {
          setFormData(formData => ({ ...formData, ipAddress: data.ip }));
        })
        .catch((error) => {
          console.log(error);
        });
    };
    fetchData();

    // //pageView
    // //access initial value from session storage
    // var pageView = sessionStorage.getItem("pageView");
    // var formSessionData = JSON.parse(sessionStorage.getItem("myFormSessionStorageData"));

    // if (pageView === null) {
    //   pageView = 0;
    //   console.log("No page view session data");
    // } else {
    //   pageView = Number(pageView);
    // }

    // if (formSessionData === null) {
    //   console.log("No form data session storage");
    // } else {
    //   setFormData(formSessionData);
    //   console.log(formSessionData.requestedAmount);
    // }

    // //update session storage
    // sessionStorage.setItem("pageView", Number(pageView));

    // console.log(JSON.parse(sessionStorage.getItem("myFormSessionStorageData")));
    // setPage(pageView);
  }, []);

  // useEffect(() => {
  //   var pageView = page;
  //   sessionStorage.setItem("pageView", pageView);
  //   let obj = formData;
  //   sessionStorage.setItem("myFormSessionStorageData", JSON.stringify(obj));
  // }, [page, formData]);

  // useEffect(() => {
  //   let obj = formData;
  //   sessionStorage.setItem("myFormSessionStorageData", JSON.stringify(obj));
  // }, [formData]);

  const componentList = [
    <RequestedAmount
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <LoanPurpose
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <CreditScore
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <EmployeeInfo
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <MonthlyIncome
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <PersonalInfo
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <OwnHome
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <CitizenshipStatus
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <DebtAmount
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <DebtStatus
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />,
    <CreditAuth
      formData={formData}
      setFormData={setFormData}
      page={page}
      setPage={setPage}
    />
  ];

  // const alertUser = (e) => {
  //   e.preventDefault();
  //   e.returnValue = "";
  // };
  // useEffect(() => {
  //   window.addEventListener("beforeunload", alertUser);
  //   return () => {
  //     window.removeEventListener("beforeunload", alertUser);
  //   };
  // }, []);

  const redirectToQuebecForm = () => {
    window.dataLayer.push({'event': 'loan_yesQuebec', 'loanEvent': 'yesQuebec', 'loanEventID': 1});
    window.location.replace("https://www.insurdinary.ca/personal-loan-quebec");
  }

  const openLoanForm = () => {
    window.dataLayer.push({'event': 'loan_noQuebec', 'loanEvent': 'noQuebec', 'loanEventID': 2});
    setOpenForm(true);
  }

  return (
    <div className='App'>
      <Header />
      <div className='form-container'>
        <div className='form-div'>

          <h1 className="form-title">{formData.lang === "fr" ? "Obtenez une estimation de prêt personnelle gratuite" : "Get Your Free Personal Loan Quote Today"}</h1>

          {!openForm ?
            <div>
              <div className="card">
                <div className="card-div">
                  <div className="textfield-label">{formData.lang === "fr" ? "Vous habitez au Québec?" : "Do you live in Québec?"}</div>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <button className="nav-button" onClick={() => redirectToQuebecForm()}>
                        {formData.lang === "fr" ? "Oui" : "Yes"}
                      </button>
                    </Grid>
                    <Grid item xs={6}>
                      <button className="nav-button" onClick={() => openLoanForm()}>
                        {formData.lang === "fr" ? "Non" : "No"}
                      </button>
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
            :
            <div>
              <div className="progress-bar">
                <div style={{
                  width:
                    page === 0 ? "0%" :
                      page === 1 ? "10%" :
                        page === 2 ? "20%" :
                          page === 3 ? "30%" :
                            page === 4 ? "40%" :
                              page === 5 ? "50%" :
                                page === 6 ? "60%" :
                                  page === 7 ? "70%" :
                                    page === 8 ? "80%" :
                                      page === 9 ? "90%" : "100%"
                }}>
                </div>
              </div>
              <div style={{ maxWidth: 500 }}>
                {componentList[page]}
              </div>
            </div>}
        </div>
      </div>
      <div style={{ marginTop: 20 }}>{formData.lang === "fr" ? "Langue" : "Language"}: <span className='language-toggle' style={{ fontWeight: formData.lang === "en" ? 600 : null }} onClick={setToEnglish}>{formData.lang === "fr" ? "Anglais" : "English"}</span> | <span className='language-toggle' style={{ fontWeight: formData.lang === "fr" ? 600 : null }} onClick={setToFrench}>{formData.lang === "fr" ? "Français" : "French"}</span></div>
      <PageContent formData={formData} />
      
      {/* <CookieConsent formData={formData} /> */}
    </div>
  );
}

export default App;